/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionRead } from './CompetitionRead';
import {
    CompetitionReadFromJSON,
    CompetitionReadFromJSONTyped,
    CompetitionReadToJSON,
    CompetitionReadToJSONTyped,
} from './CompetitionRead';

/**
 * Paginated response for competitions list.
 * @export
 * @interface PaginatedCompetitionsResponse
 */
export interface PaginatedCompetitionsResponse {
    /**
     * List of competitions
     * @type {Array<CompetitionRead>}
     * @memberof PaginatedCompetitionsResponse
     */
    items: Array<CompetitionRead>;
    /**
     * Total number of matching competitions
     * @type {number}
     * @memberof PaginatedCompetitionsResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedCompetitionsResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedCompetitionsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedCompetitionsResponse interface.
 */
export function instanceOfPaginatedCompetitionsResponse(value: object): value is PaginatedCompetitionsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedCompetitionsResponseFromJSON(json: any): PaginatedCompetitionsResponse {
    return PaginatedCompetitionsResponseFromJSONTyped(json, false);
}

export function PaginatedCompetitionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCompetitionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CompetitionReadFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedCompetitionsResponseToJSON(json: any): PaginatedCompetitionsResponse {
    return PaginatedCompetitionsResponseToJSONTyped(json, false);
}

export function PaginatedCompetitionsResponseToJSONTyped(value?: PaginatedCompetitionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CompetitionReadToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

